import React, {useEffect, useState} from "react";
import {FormattedMessage} from "react-intl";

import classes from "./styles.module.css";

const StatusCheckbox = ({category, name, count, onChange, isDisabled, isSelected}) => {
    const [checked, setChecked] = useState(!!isSelected);

    useEffect(() => {
        setChecked(!!isSelected);
    }, [isSelected]);

    // Уникальный id
    const inputId = `${category}_${name}`;

    let color;
    const title = (
        <FormattedMessage id={`TransactionsFilters.label.${name}`} defaultMessage="Перевод отсутствует"/>
    );

    switch (name) {
        case "successfulP2P":
            color = "#1abc9c";
            break;
        case "successfulSbp":
            color = "#16a085";
            break;
        case "sbp":
            color = "#27ae60";
            break;
        case "mP2P":
            color = "#2ecc71";
            break;

        case "payoutPending":
            color = "#3b1a1a";
            break;
        case "purchasePending":
            color = "#498183";
            break;
        case "threeDSPending":
            color = "#581b1b";
            break;
        case "refundPending":
            color = "#82afef";
            break;
        case "reversalPending":
            color = "#02ecab";
            break;
        case "recurrentPending":
            color = "#638b1a";
            break;
        case "mP2PPending":
            color = "#6b4c3e";
            break;
        case "sbpPending":
            color = "#2a6b6b";
            break;

        case "payoutCreated":
            color = "#5de6f8";
            break;
        case "refundCreated":
            color = "#0468f5";
            break;
        case "reversalCreated":
            color = "#058b66";
            break;
        case "recurrentCreated":
            color = "#3b5702";
            break;
        case "purchaseCreated":
            color = "#5977b3";
            break;
        case "mP2PCreated":
            color = "#8fa0d4";
            break;
        case "sbpCreated":
            color = "#6ab7c8";
            break;

        case "payoutDecline":
            color = "#DC3912";
            break;
        case "refundDecline":
            color = "#782ad4";
            break;
        case "reversalDecline":
            color = "#a9218e";
            break;
        case "recurrentDecline":
            color = "#c35624";
            break;
        case "purchaseDecline":
            color = "#a1c324";
            break;
        case "mP2PDecline":
            color = "#d4385b";
            break;
        case "sbpDecline":
            color = "#e67e22";
            break;

        case "qr":
            color = "#9b59b6";
            break;
        case "qrCreated":
            color = "#8e44ad";
            break;
        case "qrPending":
            color = "#6c3483";
            break;
        case "qrDecline":
            color = "#c0392b";
            break;

        case "mobilePayout":
            color = "#e74c3c";
            break;
        case "mobilePayoutCreated":
            color = "#c0392b";
            break;
        case "mobilePayoutPending":
            color = "#922b21";
            break;
        case "mobilePayoutDecline":
            color = "#641e16";
            break;

        case "purchase":
            color = "#3366CC";
            break;
        case "recurrent":
            color = "#a0e720";
            break;
        case "reversal":
            color = "#1eba8e";
            break;
        case "refund":
            color = "#518cea";
            break;
        case "payout":
            color = "#109618";
            break;

        case "chargeback":
            color = "#644f0b";
            break;
        case "created":
            color = "#3a828c";
            break;

        default:
            color = "#d4d4d4";
    }

    return (
        <div key={inputId} className={classes.Wrap}>
            <input
                id={inputId}
                type="checkbox"
                onChange={(e) => {
                    onChange({[name]: e.target.checked});
                    setChecked(e.target.checked);
                }}
                disabled={isDisabled}
                checked={checked}
            />

            <label htmlFor={inputId} className={classes.Checkbox}>
                <div style={{backgroundColor: color}} className={classes.Icon}/>
                <span>{title}</span>
            </label>
        </div>
    );
};

export default StatusCheckbox;



// WEBPACK FOOTER //
// ./src/Components/Utils/UI/StatusCheckbox/index.js